import axios from "axios";
import store from "@/store";
import { getNextDay } from '@/utils/time'
import router from '@/router'
let requests = axios.create({
    baseURL: 'api',
    timeout: 8000,
    retry: 2, //设置全局重试请求次数（最多重试几次请求）
    retryDelay: 1000, //设置全局请求间隔

});
let isRefresh = 0
requests.interceptors.request.use((config) => {
    if (store.getters.token) {
        if (!config.islogin) {
            config.params = {
                ...config.params,
                'access_token': store.getters.token
            }
        }
        if (config.params.endDate && !config.AddendDate) {
            config.params.endDate = getNextDay(config.params.endDate)
        }
    }
    return config
})

requests.interceptors.response.use((response) => {
    const { data } = response
    if (response.status === 200) {
        return Promise.resolve(data);
    } else {
        return Promise.reject(response);
    }
}, (error) => {
    const { config, response } = error;
    if (response && (response.status === 401 || response.status === 403) && router.currentRoute.path !== "/login") {
        isRefresh++;
        if (isRefresh == 1) {
            store.dispatch("ResetToken");
            router.push("/login")
        }
    }
    if (!config || !config.retry) {
        return Promise.reject(error)
    }
    if (!config.retryCount) {
        config.retryCount = 1;
    }
    const retryDelay = config.retryDelay || 1000;
    const retryCount = config.retryCount;
    if (retryCount <= config.retry) {
        return new Promise(resolve => {
            setTimeout(() => {
                config.retryCount++;
                resolve(requests(config));
            }, retryDelay);
        })
    }
    else return Promise.reject(error)
})

export default requests;
